import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CustomSwitch from '../../../components/Common/Switch';

class SeatingSelectionModeToggler extends PureComponent {
  render() {
    const { seatingSelectionMode, selectionModeChanged, enabled } = this.props;
    return (
      <CustomSwitch
        isChecked={seatingSelectionMode === 'zone'}
        onChange={selectionModeChanged}
        isEnabled={enabled}
        label="Select Zone"
      />
    );
  }
}

SeatingSelectionModeToggler.propTypes = {
  seatingSelectionMode: PropTypes.string.isRequired,
  selectionModeChanged: PropTypes.func.isRequired,
  enabled: PropTypes.bool.isRequired,
};

export default SeatingSelectionModeToggler;
